<!--
 * @Description: Jerry Create File
 * @Version: 1.0
 * @Autor: Jerry
 * @Date: 2021-11-26 10:24:29
 * @LastEditors: Jerry
 * @LastEditTime: 2021-12-15 20:10:03
-->
<template>
  <div v-if="ableToShow" class="bgf5">
    <iHeader />
    <iNav />
    <iClassify />
    <iRightFixedBox />
    <iPageTitle :text="pageTitle" />
    <div class="container">
      <el-row type="flex" :gutter="10">
        <el-col :span="10">
          <img class="left-img" :src="brokerageItem.ImageUrl" alt="">
        </el-col>
        <el-col :span="14" style="position: relative;">
          <div class="right-ctr-area">
            <div class="item-title">
              {{ brokerageItem.Name }}<span style="font-size: 15px;">(共{{ brokerageItem.Quantity }}张)</span>
            </div>
            <div class="item-price">
              <div class="left-price-info">
                <div class="price-item fAvenirH">¥{{ brokerageItem.Price }}</div>
                <div class="item-info">
                  <div>
                    <span>
                      <img
                        :src="require('@/assets/BrokerageCity/limit.png')"
                        alt=""
                      >
                    </span>
                    <span v-if="brokerageItem.LimitNum">限购数量 <span style="margin-left: 4px;">{{ brokerageItem.LimitNum }}</span></span>
                    <span v-else> 不限购</span>
                  </div>
                  <div v-if="DeductionMode===1 && brokerageItem.Value">
                    <span>
                      <img
                        :src="require('@/assets/BrokerageCity/price.png')"
                        alt=""
                      ></span>

                    <span>价值<span style="margin-left: 4px;">¥{{ brokerageItem.Value }}</span></span>
                  </div>
                </div>
              </div>
              <div class="right-price-info">
                <div :class="['status-of-img',`img-${Type}-${brokerageItem.Status}`]" />
                <!-- <div :class="{'status-of-Received':brokerageItem.Status === 1,'status-of-OutOfAmount':brokerageItem.Status === 2}" /> -->
                <!-- 可输入状态 -->
                <div v-if="brokerageItem.Status === 0" style="display: flex;">
                  <span v-if="brokerageItem.ReceivedNum" class="ReceivedNum"> {{ Type==1?'已购买':'已领取' }} {{ brokerageItem.ReceivedNum }}个</span>
                  <van-stepper
                    v-if=" brokerageItem.ReceivedNum<brokerageItem.LimitNum && Type==1"
                    async-change
                    :value="countValue"
                    :min="orderLimit.min"
                    :max="orderLimit.max"
                    integer
                    @change="changeQuantity"
                  />

                  <div v-if="brokerageItem.ReceivedNum>=brokerageItem.LimitNum" class="purchase-limited">  {{ Type==1?'已到限购上限':'已到领取上限' }} </div>
                </div>

              </div>
            </div>
            <!-- 商品详情 -->
            <div class="goods-ctr-area">
              <div class="goods-item-title">
                <div>商品详情</div>
              </div>
              <div class="goods-list">
                <div
                  v-for="(val, idx) in brokerageItem.CouponList"
                  :key="idx"
                  class="goods-item"
                  @click="viewDetail(val)"
                >
                  <div class="left-price-limit">
                    <div>
                      <span class="fAvenirH">{{ val.DeductionLimit }}</span>
                      <span>{{ val.DeductionMode ===1?`¥`:`折` }}</span>
                    </div>
                    <div>满{{ val.GoodsLimitPrice }}元可用</div>
                  </div>
                  <div class="right-price-info">
                    <div>
                      <span
                        :class="val.DeductionMode === 1 ? 'type1' : 'type2'"
                      >{{
                        val.DeductionMode === 1 ? '满减券' : '折扣券'
                      }}</span>
                      <span>{{ val.Range }}</span>
                    </div>
                    <div>
                      <span style="font-size: 12px;">{{
                        val.ValidityTime
                      }}</span>
                      <span class="cupon-amount fAvenirH">
                        <span style="font-size: 20px;">×</span>
                        <span
                          style="margin-left: 2px; font-size: 24px;"
                        >{{ val.CouponsQuantity }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 结算栏 -->
    <div v-if="brokerageItem.Status === 0 && brokerageItem.ReceivedNum<brokerageItem.LimitNum" class="submit">
      <!-- 操作面板 -->
      <div class="submit-c">
        <div style="font-weight: 500; color: rgba(17, 26, 52, 1);">
          已选择
          <span style="font-size: 16px; color: rgba(15, 110, 233, 1);">{{ countValue }}</span>
          件商品<span v-if=" brokerageItem.Value"> ，价值：¥{{ brokerageItem.Value }}</span>
        </div>
        <div style="display: flex; align-items: center;">
          <div class="submit-total">
            <div class="submit-sum">
              应付：
              <span
                style="display: inline-flex; justify-content: center; align-items: center;"
              ><span style="margin-right: 6px; font-size: 20px;">¥</span><span class="fAvenirH" style="font-size: 28px;">{{ Type==1? computedPrice:0 }}</span></span>
            </div>

            <div v-if="moneyRelative.Subsidy" class="submit-maoli">平台补贴：¥{{ moneyRelative.Subsidy }}</div>
          </div>
          <div>
            <van-button v-if=" Type==1" class="submit-st" square color="#FF3939" @click="goConfirm()">
              <div> 立即购买 </div>
            </van-button>
            <van-button v-if="Type==2" class="submit-get-free" square color="rgba(15, 110, 234, 1)" @click="goGetOfFree()">
              <div> 免费领取 </div>
            </van-button>
          </div>

        </div>

        <van-button v-if="brokerageItem.Status == 2" disabled><div>已领完</div></van-button>
      </div>
    </div>
    <!-- /结算栏 -->

    <!-- /领取成功弹窗 -->

    <!-- 券详情弹窗 -->
    <div>
      <el-dialog
        v-if="dialogDetails"
        :visible.sync="dialogDetails"
        width="320px"
        top="0"
        class="dialog-receive-details"
        :show-close="false"
      >
        <div class="head-img-ctr">
          <div style="font-size: 16px;"> {{ currentDialogInfo.Range }}</div>
          <div>
            <span style="font-size: 50px;" class="fAvenirH">{{ currentDialogInfo.DeductionMode ===1?`¥${ currentDialogInfo.DeductionLimit }`:`${ currentDialogInfo.DeductionLimit }折` }}</span>

            <span class="brokrage-type-1">{{ currentDialogInfo.DeductionMode ===1?'满减券':'折扣券' }}</span>
          </div>
        </div>
        <div class="box-container">

          <div class="dialog-successed-box">
            <div class="m-top">
              <label>使用条件:</label>
              <span>满¥{{ currentDialogInfo.GoodsLimitPrice }}可用</span>
            </div>
            <div>
              <label>有效期至:</label>
              <span>{{ currentDialogInfo.ValidityTime }}</span>
            </div>
            <div>
              <label>适用范围:</label>
              <span v-if="currentDialogInfo.GoodSkuNames"> {{ currentDialogInfo.GoodSkuNames }} </span>
              <span v-else>  {{ currentDialogInfo.Range }} </span>
            </div>

          </div>
          <el-button class="btn" type="primary" @click="dialogDetails = false"> 确定</el-button>
        </div>
        <span> <img class="close-btn" :src="require('../../assets/BrokerageCity/close.png')" alt="" @click="dialogDetails = false"> </span>

      </el-dialog>

    </div>
    <!-- /券详情弹窗 -->
    <!-- receiveDialog -->
    <receive-dialog ref="receiveDialog" />
    <iFooter />
  </div>
</template>

<script>
import iHeader from '@/components/Header'
import iNav from '@/components/Nav'
import iClassify from '@/components/Classify'
import iPageTitle from '@/components/PageTitle'
import iFooter from '@/components/Footer'
import iRightFixedBox from '@/components/RightFixedBox'

import receiveDialog from './components/BrokerageCity/receiveDialog'
export default {
  name: 'BrokerageDetail',
  components: {
    iHeader,
    iNav,
    iFooter,
    iRightFixedBox,
    iClassify,
    iPageTitle,
    receiveDialog
  },
  data() {
    return {
      pageTitle: ['我的账户', '券详情'],
      ableToShow: false,
      brokerageItem: null,
      dialogDetails: false,
      dialogSucceed: false, // 领取成功弹窗
      countValue: 0,
      orderLimit: {
        number: 1,
        min: 1,
        max: 0// 默认值
      },
      moneyRelative: {
        Price: 0, // 应付
        Value: 0, // 价值
        Subsidy: 0 // 平台补贴
      },
      url: {
        receive: '/api_coupon/CouponMall/CouponReceive', // 免费领取
        detail: '/api_coupon/CouponMall/CouponDetail',
        change: '/api_coupon/couponMall/changeQuantity'
      },
      DeductionMode: 1, // （1 满减券  2 折扣券）
      DeductionMoney: 0, // 折扣价格
      id: null,
      SaleCouponsMgtId: null,
      Type: null, // 1付费买 2免费领取
      currentDialogInfo: null
    }
  },
  computed: {
    computedPrice() {
      // 需要计算折扣
      return this.moneyRelative.Price
    }
  },
  mounted() {
    const { Id, Type, SaleCouponsMgtId } = this.$route.query
    if (!Id || !Type || !SaleCouponsMgtId) {
      this.$toast({ position: 'bottom', message: '订单数据异常' })
      window.history.back()
      return
    }
    this.id = Id
    this.Type = Type
    this.SaleCouponsMgtId = SaleCouponsMgtId
    this.getItemInfo(this.$route.query.Id)
  },
  methods: {
    /**
     * @description: 领取
     * @param {*} val
     * @return {*}
     */
    async goGetOfFree() {
      const item = this.brokerageItem
      //  this.$refs.receiveDialog.setStatus(true, item.Name)
      // 免费领取
      if (item.Status == 0) {
        const res = await this.getAction(this.url.receive, { from: 2, id: item.Id, SaleCouponsMgtId: item.SaleCouponsMgtId })
        if (res.IsSuccess) {
          this.getItemInfo(this.id)
          this.$refs.receiveDialog.setStatus(true, item.Name)
        } else {
          this.$toast({ position: 'bottom', message: res.Msg })
        }
      }
    },
    async getItemInfo(id) {
      this.$hys.openLoading()

      // 获取券包详情
      const res = await this.getAction(this.url.detail, {
        from: 2,
        SaleCouponsMgtId: this.SaleCouponsMgtId,
        id
      })
      if (res.IsSuccess) {
        this.brokerageItem = res.Data
      } else if (res.ErrorCode === 10001) {
        this.$toast(res.Msg)
        this.$router.back()
      } else {
        this.$toast(res.Msg)
        return
      }

      this.orderLimit.max = this.brokerageItem.LimitNum - this.brokerageItem.ReceivedNum // 限购数等于 总量减去已获得

      this.countValue = this.brokerageItem.LimitNum > this.brokerageItem.ReceivedNum ? 1 : 0 // 默认购买一个
      // 如果没达到购买上限 则请求价格相关信息
      if (this.brokerageItem.ReceivedNum < this.brokerageItem.LimitNum) {
        this.changeQuantity(this.countValue)
      }
      // 查看是否所有都是满减
      this.DeductionMode = this.brokerageItem.CouponList.every(val => val.DeductionMode == 1) ? 1 : 2
      this.DeductionMoney = this.brokerageItem.CouponList.reduce((pre, next) => pre + next.DeductionLimit, 0)

      this.ableToShow = true
      this.$hys.clearLoading()
    },

    /**
     * @description: 改变购买数量
     * @param {*} value
     * @return {*}
     */
    async changeQuantity(value) {
      // if (value == this.countValue && value != 1) {
      //   return
      // }
      const t = this.countValue
      this.$hys.openLoading()
      const res = await this.postAction(this.url.change, {
        From: 2,
        Id: this.id,
        Quantity: value,
        SaleCouponsMgtId: this.brokerageItem.SaleCouponsMgtId,
        SellType: this.Type
      })
      // 待处理
      if (res.IsSuccess) {
        //
        this.moneyRelative = res.Data
        this.moneyRelative.Subsidy === null ? this.moneyRelative.Subsidy = 0 : this.moneyRelative.Subsidy
        this.moneyRelative.Value === null ? this.moneyRelative.Value = 0 : this.moneyRelative.Value
        this.countValue = value
      } else {
        this.$message({
          message: res.Msg,
          type: 'error'
        })
        this.countValue = t
      }
      this.$hys.clearLoading()
    },
    /**
     * @description: 查看券详情
     * @param {*} val
     * @return {*}
     */
    viewDetail(val) {
      this.dialogDetails = true
      this.currentDialogInfo = val
    },
    /**
     * @description: 免费领取
     * @param {*}
     * @return {*}
     */
    async handleReceive() {
      const res = await this.getAction(this.url.receive, { from: 2, id: this.brokerageItem.Id, SaleCouponsMgtId: this.brokerageItem.SaleCouponsMgtId })
      if (res.IsSuccess) {
        this.getInfo()
        this.$refs.receiveDialog.show(this.detailInfo.Name)
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    /**
     * @description: 去支付
     * @param {*} val
     * @return {*}
     */
    async goConfirm() {
      this.$router.push({
        name: 'BrokerageConfirmOrder',
        params: {
          dataSource: this.brokerageItem,
          number: this.countValue
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@import url("./style/brokerageDetails.less");

</style>
